import React, { FunctionComponent } from 'react';
import { Route as DomRoute, RouteProps } from 'react-router-dom';
import { RouterContext } from './RouterContext';

export const RouteProvider: FunctionComponent = ({
  children,
  ...routeProps
}) => {
  function isActive(route: string) {
    const match = (routeProps as any).match;
    if (!match) return false;
    if (route === '/') return match.url === '/';
    return match.url.substring(0, route.length) === route;
  }
  return (
    <RouterContext.Provider value={{ ...routeProps, isActive }}>
      {children}
    </RouterContext.Provider>
  );
};
